import React, { useEffect, useState, useCallback } from 'react'
import styled from '@emotion/styled'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClipboardList } from '@fortawesome/pro-regular-svg-icons/faClipboardList'

import { useConfig } from '@peracto/peracto-config'
import axios from 'axios'

import FormGenerator from './FormGenerator'
import { Checkbox, CheckboxGroup, Button, Input, Textarea, Select, Radio, File } from './Inputs'
import { isInStorefront } from '../../utils/isInStorefront'

const FormWrapper = styled.div`
    max-width: ${props => `${props.maxwidth}%`};
`

let Icon = () => (
    <div className="d-flex justify-content-center align-items-center py-5">
        <FontAwesomeIcon icon={faClipboardList} size="6x" />
    </div>
)

const FormComponent = ({ state: { formId, maxWidth = 100, hideTitle = false } }) => {
    const config = useConfig()
    const API_URL = config.get('api')

    const [formData, setFormData] = useState()
    const defaultInputs = { Checkbox, CheckboxGroup, Button, Input, Textarea, Select, Radio, File }

    const fetchFormData = useCallback(async formId => {
        try {
            axios.get(API_URL + formId).then(res => {
                const data = res.data
                const form = {
                    ...data,
                    formFieldLinks: data.formFieldLinks.map(field => {
                        const formField = field.formField
                        return {
                            mandatory: field.mandatory === true,
                            ...formField,
                        }
                    }),
                }

                setFormData(form)
            })
        } catch (e) {
            console.error(e)
        }
    }, [])

    useEffect(() => {
        if (formId) {
            fetchFormData(formId)
        }
    }, [formId])

    const inStorefront = isInStorefront()

    return (
        <div>
            {formId ? (
                <FormWrapper maxwidth={maxWidth} className="content__form">
                    <FormGenerator
                        hideTitle={hideTitle}
                        formData={formData}
                        defaultInputs={defaultInputs}
                    />
                </FormWrapper>
            ) : inStorefront ? (
                <></>
            ) : (
                <Icon />
            )}
        </div>
    )
}

export default FormComponent
